import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Pain points" className="border-y border-grape/10 bg-white/70" data-id="element-108" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-6" data-id="element-109" data-mp="26xmrx1867me0">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-110" data-mp="2bx95jbrwv4nc">
          Does this sound like you?
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-center text-base leading-relaxed text-plum/70" data-id="element-111" data-mp="1xwyg8d691y4a">
          <p data-id="element-112" data-mp="220waoakmqkr0">
            You know electrical engineering. You understand calculations, equipment, technical specifications,
            drawings, and the importance of getting the details right.
          </p>
          <p data-id="element-113" data-mp="1t0r6086tm0gj">
            But when you open an AI assistant to help with a technical task, you can lose valuable time figuring
            out what to ask, what information to provide, and how to turn a generic response into something useful
            for your actual work.
          </p>
          <p data-id="element-114" data-mp="1yyu658j6dta3">
            You want to benefit from AI without compromising technical rigor, professional standards, or your own
            engineering judgment.
          </p>
        </div>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg font-bold text-plum" data-id="element-115" data-mp="27sgy0nk9ice0">
          It’s not necessarily a lack of technical knowledge. It’s the challenge of having a{' '}
          <span className="text-grape" data-id="element-116" data-mp="1g2udrwmacnpz">structured AI framework for engineering work</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-117" data-mp="1b417ao5f1wzb">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" data-id="element-118" data-mp="1p2r21x4rjkki" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-119" data-mp="1t55aq8oucxwh">
                {p.emoji}
              </span>
              <div data-id="element-120" data-mp="1y62p0a6qd7sp">
                <h3 className="text-sm font-bold text-plum" data-id="element-121" data-mp="225bl3lp8thrf">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-122" data-mp="2240jnsj9sm3h">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-123" data-mp="1afgm0xbl2dpk">
          <p className="mx-auto max-w-2xl font-display text-xl font-bold text-plum sm:text-2xl" data-id="element-124" data-mp="1ackmx5o01izj">
            ✨ If you answered YES, SIGMA SMART™ has developed a practical system to help you approach AI-assisted
            engineering work with greater structure.
          </p>
        </div>
      </div>
    </section>;
}